import * as React from "react";
import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";

interface PriceSliderProps {
  minPrice: number;
  maxPrice: number;
  value: [number, number];
  onValueChange: (value: [number, number]) => void;
}

export function PriceSlider({ minPrice, maxPrice, value, onValueChange }: PriceSliderProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Price Range</Label>
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>${value[0]}</span>
          <span>${value[1]}</span>
        </div>
      </div>
      <Slider
        variant="default"
        className="w-full"
        minStepsBetweenThumbs={1}
        min={minPrice}
        max={maxPrice}
        step={1}
        value={value}
        onValueChange={onValueChange}
      />
    </div>
  );
} 